import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useState } from "react";
import { formatMonthDate } from "../constants";
import ExpandableText from "./ExpandableText";

const DeliveredOrderCard = ({ order }) => {
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showDeliveryDetails, setShowDeliveryDetails] = useState(false);

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  return (
    <>
      <div className="col-12 col-md-6 mb-3" key={order.ordercode}>
        <div className="modern-order-card">
          {/* ===== Top Header ===== */}
          <div className="card-top mb-2">
            <div>
              <h6 className="order-number fw-bold">
                <i className="fa-solid fa-box text-primary"></i> Order #
                {order.ordercode}
              </h6>
              <h6 className="order-number fw-bold">
                {" "}
                Sale Order Id #{order.saleheadercode}
              </h6>
              <span
                className="badge time cursor-pointer"
                onClick={() => {
                  setSelectedOrder(order);
                  setShowItemModal(true);
                }}
              >
                Total Items : {order.sale_totalitem}
              </span>

              <div className="badges" title={order.order_remark}>
                <span className="badge distance">
                  <ExpandableText
                    text={`Remark : ${order.order_remark} `}
                    maxLength={30}
                    className="long-remark-text mb-1"
                  />
                </span>
              </div>
            </div>

            <div>
              <h6 className="order-number">Total Amount</h6>

              <span className="amount-section text-dark">
                ₹{order.sale_totalamount}
              </span>

              <h6 className="order-number">
                {order.sale_remainingamount > 0 ? (
                  <>
                    <span className="red-error">Bal Amt:</span>
                    <span className="bal-amount-section  ms-2">
                      ₹{order.sale_remainingamount}
                    </span>
                  </>
                ) : (
                  <span className="amount-section">Paid</span>
                )}
              </h6>
            </div>
          </div>

          {/* ===== Branch Section ===== */}
          <div className="section ">
            <h6 className="section-title mt-1 fw-bold">
              <i className="fa-solid fa-store text-primary"></i> Branch
            </h6>

            <div className="row">
              <div className="col-6">
                <span className="label"><i className="fa-solid fa-user-tag text-warning"></i> Name: </span>
                <ExpandableText
                  text={`${order.branchname} (${order.branchcode})`}
                  maxLength={30}
                  className="long-remark-text mb-1"
                />
              </div>

              <div className="col-6">
                <p className="mb-2">
                  <span className="label"><i className="fa-solid fa-phone text-warning"></i> Mobile:</span> {order.branchmobile}
                </p>
              </div>
              <div className="col-12">
                <span className="label"><i className="fa-solid fa-house text-warning"></i> Address: </span>
                <ExpandableText
                  text={order.branchaddress}
                  maxLength={30}
                  className="long-main-card-text mb-1"
                />
                {order.branch_location && (
                  <button
                    type="button"
                    className="map-btn "
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(
                        `https://www.google.com/maps?q=${order.branch_location}`,
                        "_blank"
                      );
                    }}
                  >
                    <i className="fa-solid fa-location-dot"></i>
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* ===== Customer + Order Info ===== */}
          <div className="d-flex section two-column ">
            {/* Customer */}
            {/* <div className="col-6 border-end"> */}
            <div className="col-12 mt-1">
              <h6 className="fw-bold section-title">
              <i className="fa-solid fa-user-circle text-primary"></i> Customer
              </h6>
              <div className="row">
                <div className="col-6">
                  <span className="label"><i className="fa-solid fa-user-tag text-warning"></i> Name: </span>
                  <ExpandableText
                    text={` ${order.customername} (${order.customercode})`}
                    maxLength={30}
                    className="long-remark-text mb-1"
                  />
                </div>
                <div className="col-6">
                  <p className="mb-2">
                    <span className="label"><i className="fa-solid fa-phone text-warning"></i> Mobile:</span>{" "}
                    {order.customer_mobile_no}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ===== Delivery Section ===== */}

          <div className="section delivery-box">
            <div className="d-flex justify-content-between align-items-center mb-2">
              {/* Left Title */}
              <h6 className="fw-bold d-flex align-items-center mb-0">
                <span className="me-2 delivery-icon">
                  <i className="fa-solid fa-truck text-primary"></i>
                </span>
                Delivery Info
              </h6>
              <div
                className="tracking-pill d-flex align-items-center cursor-pointer"
                onClick={() => {
                  setSelectedOrder(order);
                  setShowDeliveryDetails(true);
                }}
              >
                <i className="fa-solid fa-eye me-2"></i>
                Tracking Details
              </div>
            </div>
            <div className="mb-0 ">
              <span className="label"><i className="fa-solid fa-house text-warning"></i> Address: </span>
              <ExpandableText
                text={` ${order.delivery_address}, ${order.delivery_pincode}`}
                maxLength={30}
                className="long-text mb-1"
              />

              {order.delivery_location && (
                <button
                  type="button"
                  className="map-btn "
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(
                      `https://www.google.com/maps?q=${order.delivery_location}`,
                      "_blank"
                    );
                  }}
                >
                  <i className="fa-solid fa-location-dot"></i>
                </button>
              )}
            </div>

            <div className="row">
              <div className="col-6">
                <span className="label"><i className="fa-solid fa-clock text-warning"></i> Time Slot:</span> {order.delivery_time_slot}
              </div>

              <div className="col-6">
                <span className="label"><i className="fa-solid fa-route text-warning"></i> Distance:</span>{" "}
                {order.delivery_distance} km
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showItemModal}
        onHide={() => setShowItemModal(false)}
        size="lg"
        centered
        backdrop="static"   
        keyboard={false}   
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title>
              Order #{selectedOrder?.ordercode} – Sale Items
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="table-container">
              <div className="table-responsive">
                <table className="table table-dark table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th className="text-center">Sr. No.</th>
                      <th>Item Name</th>
                      <th className="text-center">Qty</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedOrder?.sale_details?.length > 0 ? (
                      selectedOrder.sale_details.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>
                            {" "}
                            <ExpandableText
                              text={`${item.itemname}`}
                              maxLength={30}
                              className="long-text mb-1"
                            />
                          </td>
                          <td className="text-center">{item.qty}</td>
                          <td className="text-end">
                            ₹{Number(item.amount).toFixed(2)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No items found
                        </td>
                      </tr>
                    )}
                  </tbody>

                  {selectedOrder?.sale_details?.length > 0 && (
                    <tfoot>
                      <tr>
                        <th colSpan="3" className="text-end px-2">
                          Total Amount
                        </th>
                        <th className="text-end">
                          ₹
                          {selectedOrder.sale_details
                            .reduce((sum, item) => sum + Number(item.amount), 0)
                            .toFixed(2)}
                        </th>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowItemModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showDeliveryDetails}
        onHide={() => setShowDeliveryDetails(false)}
        centered
        size="lg"
        className="delivery-details-modal"
        backdrop="static"   
        keyboard={false}   
      >
        <Modal.Header closeButton className="modal-header-custom py-2">
          <Modal.Title className="d-block">
            <div className="text-theme">
              <i className="fas fa-truck me-2"></i>
              Tracking Details
            </div>
            <div>Order ID: #{selectedOrder?.ordercode}</div>
            <div> Customer: {selectedOrder?.customername}</div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">
          <div className="modal-content-wrapper">
            {/* Assignment and Pickup Row */}
            <div className="row-container">
              {/* Order Assignment Section */}
              <div className="section-delivery">
                <div className="section-header">
                  <i className="fas fa-clipboard-list"></i>
                  <span>Assign Order</span>
                </div>

                <div className="info-row">
                  <span className="info-label">Assigned To</span>
                  <span className="info-value ">
                    <ExpandableText
                      text={user.name}
                      maxLength={30}
                      className="long-text"
                    />
                  </span>
                </div>
                <div className="info-row">
                  <span className="info-label">Date / Time</span>
                  <span className="info-value">
                    {formatMonthDate(selectedOrder?.delivery_pick_up_date)},{" "}
                    {selectedOrder?.delivery_pick_up_time}
                  </span>
                </div>
              </div>
              {/* Down Arrow */}
              {/* Right Arrow - Desktop Only */}
              <div className="arrow-container mt-lg-5 d-none d-lg-flex">
                <div className="arrow-right">
                  <i className="fas fa-arrow-right"></i>
                </div>
              </div>

              {/* Down Arrow - Mobile Only */}
              <div className="arrow-container d-flex justify-content-center d-lg-none my-0">
                <div className="arrow-down">
                  <i className="fas fa-arrow-down"></i>
                </div>
              </div>

              {/* Pickup Details Section */}
              <div className="section-delivery">
                <div className="section-header">
                  <i className="fas fa-box"></i>
                  <span>Pickup Order</span>
                </div>
                <div className="info-row d-flex">
                  <span className="info-label">Location</span>
                  <span className="info-value ">
                    <ExpandableText
                      text={selectedOrder?.branchaddress}
                      maxLength={30}
                      className="long-text"
                    />
                    {order.branch_location && (
                      <button
                        type="button"
                        className="map-btn "
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(
                            `https://www.google.com/maps?q=${order.branch_location}`,
                            "_blank"
                          );
                        }}
                      >
                        <i className="fa-solid fa-location-dot"></i>
                      </button>
                    )}
                  </span>
                </div>
                <div className="info-row d-flex">
                  <span className="info-label">Date / Time</span>
                  <span className="info-value">
                    {formatMonthDate(selectedOrder?.start_delivery_date)},{" "}
                    {selectedOrder?.start_delivery_time}
                  </span>
                </div>
              </div>
            </div>

            {/* Down Arrow */}
            <div className="arrow-container">
              <div className="arrow-down">
                <i className="fas fa-arrow-down"></i>
              </div>
            </div>

            {/* Delivery Details Section */}
            <div className="section-delivery delivery-section">
              <div className="section-header">
                <i className="fas fa-truck"></i>
                <span>Delivery Details</span>
              </div>

              <div className="info-row">
                <span className="info-label">Address</span>
                <span className="info-value ">
                  <ExpandableText
                    text={selectedOrder?.delivery_address}
                    maxLength={30}
                    className="long-text"
                  />
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">Date / Time</span>
                <span className="info-value">
                  {formatMonthDate(selectedOrder?.delivered_date) || ""},{" "}
                  {selectedOrder?.delivered_time}
                </span>
                <span className="info-label">Delivered Location</span>
                <span className="info-value">
                  {order.delivered_location && (
                    <button
                      type="button"
                      className="map-btn "
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(
                          `https://www.google.com/maps?q=${order.delivered_location}`,
                          "_blank"
                        );
                      }}
                    >
                      <i className="fa-solid fa-location-dot"></i>
                    </button>
                  )}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">Remark</span>
                <span className="info-value ">
                  <ExpandableText
                    text={selectedOrder?.delivery_remark}
                    maxLength={30}
                    className="long-text"
                  />
                </span>
              </div>

              {/* Delivery Image */}
              {selectedOrder?.delivery_image && (
                <>
                  <div className="timestamp">
                    <i className="fas fa-camera text-dark"></i>
                    <span>Photo captured at delivery location</span>
                  </div>
                  <div className="image-preview d-flex justify-content-center">
                    <img
                      src={selectedOrder.delivery_image}
                      alt="Delivery Proof"
                      className="img-fluid mt-2 rounded "
                      style={{ maxWidth: "400px", maxHeight: "550px" }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeliveredOrderCard;
